import {ActionTree, GetterTree, MutationTree} from 'vuex';
import {User} from "@/models/User";
import {RootState} from '../types';
import {GetterTypes, MutationTypes, UserState} from './types';
// import UserService from "@/services/UserService";

const namespaced: boolean = true;

// const userService: UserService = new UserService();

const state: UserState = {
    loggedUser: null
};

const getters: GetterTree<UserState, RootState> = {
    [GetterTypes.GET_LOGGED_USER](state): User | null {
        return state.loggedUser;
    }
};

const actions: ActionTree<UserState, RootState> = {

};

const mutations: MutationTree<UserState> = {
    [MutationTypes.SET_LOGGED_USER](state, payload : User | null): void {
        state.loggedUser = payload;
    }
};

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations
};
